import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "These 19 Words are the Only Self-Help & Business Advice You Need",
  "description": "",
  "published": "2016-11-07T00:00:00.000Z",
  "redirect_from": ["/blog/only-self-help-business-advice-you-need/swizec/7190"],
  "categories": "Business, Freelancing, Learning, Opinions, Personal, Side Projects, Startups",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This sums up every self-help and business book, blog post, podcast, and talk I’ve ever seen/read/whatever:`}</p>
    <ul>
      <li parentName="ul">{`pick a direction`}</li>
      <li parentName="ul">{`listen to users/customers/people-you-care-about`}</li>
      <li parentName="ul">{`adjust course`}</li>
      <li parentName="ul">{`do the work`}</li>
      <li parentName="ul">{`repeat until success`}</li>
    </ul>
    <p>{`Anything more is just tactics or advice on the level of `}<em parentName="p">{`"These are the lottery numbers that worked for me"`}</em>{`.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`"When successful people give advice, I usually hear it like this: 'These are the lottery numbers that worked for me...'" -- `}<a parentName="p" {...{
          "href": "https://twitter.com/sivers"
        }}>{`@sivers`}</a></p>{`— wallingf (@wallingf) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/wallingf/status/760484001492590592"
      }}>{`August 2, 2016`}</a></blockquote>
    <p>{`Let me explain it to you like you're `}<del parentName="p">{`five`}</del>{` a computer. Time for `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Stochastic_optimization"
      }}>{`stochastic search algorithms`}</a>{`! `}{`\\`}{`o/ My favorite and nerdiest way to think about life.`}</p>
    <p>{`Let's say you're you, and you want to have the best life you can. You don't know what you're looking for, and you don't know how to get there. You think you'll recognize "best life" once you're there. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Hedonic_treadmill"
      }}>{`Psychology says that you won't`}</a>{`.`}</p>
    <p>{`Your life is an optimization problem. You pick a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Fitness_function"
      }}>{`fitness function`}</a>{` and search for the combination of inputs that returns the highest result – the global maximum.`}</p>
    <p>{`Your fitness function can be anything from `}<em parentName="p">{`"How much `}{`\\`}{`$`}{`\\`}{`$ I'm making"`}</em>{` to `}<em parentName="p">{`"How happy do I feel on average"`}</em>{`. Often, it's a combination of things. People often have a function called "career", another called "family", and still another called "health".`}</p>
    <p>{`YMMV`}</p>
    <h2 {...{
      "id": "pick-a-direction"
    }}>{`Pick a direction`}</h2>
    <p>{`In the beginning, you know nothing about the world, the problem you're solving, or the destination. Any direction will do as long as you're not standing still.`}</p>
    <h2 {...{
      "id": "listen-to-people-you-care-about"
    }}>{`Listen to people you care about`}</h2>
    <p>{`Use your fitness function to see if your direction is correct.`}</p>
    <p>{`A good proxy is talking to the people you care about. Users and customers will tell you if you're making things better or worse and what they want or need. Your friends, your family, and your gut will tell you if you're becoming a better person.`}</p>
    <p>{`Trust your gut.`}</p>
    <h2 {...{
      "id": "adjust-course"
    }}>{`Adjust course`}</h2>
    <p>{`If people keep asking you to do X, and you're doing Y, try X. Your fitness function might improve quicker.`}</p>
    <p>{`Probes in random directions are a good way to find promising new directions.`}</p>
    <h2 {...{
      "id": "do-the-work"
    }}>{`Do the work`}</h2>
    <p>{`Keep going.`}</p>
    <p>{`If you don't do the work, you don't get the results. `}<strong parentName="p">{`This is the most important step`}</strong>{`.`}</p>
    <p>{`You start with huge steps, then make your steps smaller and smaller as you approach the optimum. Otherwise, you might overshoot the peak.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/11/giphy-2.gif",
        "alt": "giphy-2"
      }}></img></p>
    <h2 {...{
      "id": "repeat-until-success"
    }}>{`Repeat until success`}</h2>
    <p>{`This is an iterative algorithm. The more iterations you perform, the closer to optimum you'll get.`}</p>
    <p>{`When you find `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Maxima_and_minima"
      }}><em parentName="a">{`an`}</em>{` optimum`}</a>{`, and there are many, you can shake things up and try finding a better optimum.`}</p>
    <p>{`Starting again from `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Random_forest"
      }}>{`a random location`}</a>{`, `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Monte_Carlo_method"
      }}>{`trying random things`}</a>{`, or `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Simulated_annealing"
      }}>{`taking a few large steps`}</a>{` should knock you out of a local optimum and get you back on the path towards the global optimum.`}</p>
    <p>{`How fast you get to optimum, and how high it is, depends on factors largely outside your control: luck in picking your initial direction, fortune of circumstance and ability, "life events", and macroeconomic trends.`}</p>
    <p>{`Good luck.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      